import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

/** Reveal suave sin librerías (Apple-like) */
function Reveal({ children, className = "", delay = 0 }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          obs.disconnect();
        }
      },
      { threshold: 0.12 }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={[
        "transition-all duration-700 ease-out will-change-transform",
        show ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-8 blur-[10px]",
        className,
      ].join(" ")}
    >
      {children}
    </div>
  );
}

function Divider({ tone = "light" }) {
  return (
    <div className="mx-auto max-w-7xl px-6 py-14">
      <div className={tone === "dark" ? "h-px bg-white/10" : "h-px bg-black/5"} />
    </div>
  );
}

export default function QuienesSomos() {
  return (
    <main className="bg-white text-slate-900">
      {/* ========= HERO ========= */}
      <section className="mx-auto max-w-7xl px-6 pt-10 md:pt-14">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.18em] text-slate-500">
            QUIÉNES SOMOS
          </p>

          <h1 className="mt-6 text-5xl md:text-7xl font-semibold tracking-tight">
            Cardin Company.
          </h1>

          <p className="mt-9 max-w-2xl text-lg md:text-xl leading-relaxed text-slate-600">
            Somos una empresa familiar peruana, encargada de distribuir gelatina comestible para cocina, repostería y producción. 
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <Link
              to="/gelatinas"
              className="inline-flex rounded-full bg-slate-900 px-6 py-3 text-[14px] font-medium text-white shadow-sm transition hover:bg-black active:scale-[0.99]"
            >
              Ver gelatinas
            </Link>

            <Link
              to="/donde-comprar"
              className="inline-flex rounded-full border border-black/10 bg-white px-6 py-3 text-[14px] font-medium text-slate-900 shadow-sm transition hover:bg-slate-50 active:scale-[0.99]"
            >
              Dónde comprar
            </Link>
          </div>
        </Reveal>
      </section>

      <Divider />

      {/* ========= BLOQUE: 2 AUDIENCIAS (HOGAR / EMPRESAS) ========= */}
      <section className="bg-gradient-to-b from-[#fbf7ef] via-white to-white">
        <div className="mx-auto max-w-7xl px-6 py-20 md:py-28">
          <Reveal>
            <p className="text-xs font-semibold tracking-[0.18em] text-slate-500">
              PARA QUIÉN
            </p>

            <h2 className="mt-6 text-4xl md:text-6xl font-semibold tracking-tight">
              Dos necesidades.
              <span className="text-slate-400"> La misma claridad.</span>
            </h2>

            <p className="mt-9 max-w-2xl text-lg leading-relaxed text-slate-600">
              La gelatina no se compra solo por “Bloom”. Depende del uso. Por eso separamos la
              información en dos rutas.
            </p>
          </Reveal>

          <div className="mt-16 grid gap-14 md:grid-cols-2">
            <Reveal delay={80}>
              <div className="space-y-6">
                <p className="text-xs font-semibold tracking-[0.18em] text-slate-500">
                  HOGAR / EMPRENDEDORES
                </p>
                <p className="text-2xl md:text-3xl font-semibold tracking-tight">
                  Repostería, cocina y pruebas rápidas.
                </p>
                <p className="text-base leading-relaxed text-slate-600">
                  Recomendaciones simples: qué cambia entre Bloom, qué resultado esperar y cómo elegir
                  según el tipo de producto.
                </p>

                <div className="pt-6">
                  <div className="h-px bg-black/5" />
                </div>

                <ul className="space-y-3 text-slate-700">
                  <li className="leading-relaxed">• Elección por resultado: firmeza, estabilidad, textura.</li>
                  <li className="leading-relaxed">• Presentaciones y disponibilidad.</li>
                  <li className="leading-relaxed">• Envío y compra directa.</li>
                </ul>
              </div>
            </Reveal>

            <Reveal delay={140}>
              <div className="space-y-6">
                <p className="text-xs font-semibold tracking-[0.18em] text-slate-500">
                  EMPRESAS
                </p>
                <p className="text-2xl md:text-3xl font-semibold tracking-tight">
                  Producción, consistencia por lote y soporte.
                </p>
                <p className="text-base leading-relaxed text-slate-600">
                  Coordinamos documentación y parámetros que ayudan a estandarizar: presentación,
                  requerimientos del proceso y criterios de calidad.
                </p>

                <div className="pt-6">
                  <div className="h-px bg-black/5" />
                </div>

                <ul className="space-y-3 text-slate-700">
                  <li className="leading-relaxed">• FT / MSDS cuando se requiere.</li>
                  <li className="leading-relaxed">• Selección de presentación según operación.</li>
                  <li className="leading-relaxed">• Atención para compras recurrentes.</li>
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </section>


    </main>
  );
}
